<template>
  <div>
    <div
      v-if="getSavePrepareList.length > 0 && getSavePrepareList.includes(id)"
    >
      {{ saveComponentData() }}
    </div>
    <div v-if="getUpdateList.length > 0 && getUpdateList.includes(id)">
      {{ initData() }}
    </div>
    <div v-if="getCodeForRunAnswer != null">{{ processResult() }}</div>
    <div v-if="getCodeDeleteResults">{{ deleteResults() }}</div>
    <div v-if="getCodeInputData.step == 1">{{ prepareInputData() }}</div>
    <div v-if="getCodeKernelReset">{{ processKernelReset() }}</div>

    <div class="px-6">
      <v-card class="shadow-none">
        <v-card-text class="etype-jupyter">
          <v-layout
            row
            wrap
            v-for="(item, index) in Cells"
            :key="index"
            :class="[
              'border-all',
              index == activeContentIndex
                ? 'active-border-style'
                : 'border-color-transparent',
            ]"
          >
            <v-col
              @click="changeIndex(index)"
              :class="[
                index == activeContentIndex
                  ? 'border-r'
                  : 'border-color-transparent',
              ]"
            >
              <v-row class="my-1">
                <div class="d-flex mx-2 align-items-center">
                  <small>
                    <b>&nbsp;[{{ index }}]</b>
                  </small>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="margin-left: 12px"
                        dark
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        :ripple="false"
                      >
                        <small>{{ item.cell_type.substring(0, 4) }}</small>
                        <v-icon small style="margin-left: -8px"
                          >mdi-dots-vertical</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item
                        v-for="(item2, index2) in cellTypes"
                        :key="index2"
                        @click="changeCellType(index, index2)"
                      >
                        <v-list-item-title>{{ item2 }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div class="d-flex justify-end ml-auto">
                  <v-icon
                    small
                    title="Duplicate this cell"
                    @click="duplicateCell(index)"
                    class="mx-1"
                    >layers
                  </v-icon>
                  <v-icon
                    small
                    title="Delete this cell"
                    @click="deleteCell(index)"
                    class="mx-1"
                    >delete
                  </v-icon>

                  <div class="arrow-ordering-items mx-2">
                    <v-icon
                      @click="index > 0 ? moveCellUp(index) : ''"
                      :class="[
                        'material-icons-round',
                        index > 0
                          ? ''
                          : 'arrow-ordering-items__icon--disabled cursor-not-allowed',
                      ]"
                      title="Move cell up"
                      >arrow_upward</v-icon
                    >
                    <v-icon
                      @click="
                        index < Cells.length - 1 ? moveCellDown(index) : ''
                      "
                      :class="[
                        'material-icons-round',
                        index < Cells.length - 1
                          ? ''
                          : 'arrow-ordering-items__icon--disabled cursor-not-allowed',
                      ]"
                      title="Move cell down"
                      >arrow_downward</v-icon
                    >
                  </div>

                  <v-icon
                    v-if="item.cell_type == cellTypes[3]"
                    small
                    title="Help with math"
                    @click="openMathAPI()"
                    >help
                  </v-icon>
                </div>
              </v-row>

              <v-row class="etype-jupyter__options-box mt-3 mb-1 px-2">
                <v-col
                  v-if="item.cell_type == cellTypes[1]"
                  cols="4"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="4"
                >
                  <v-card class="transparent" :elevation="0">
                    <v-row class="etype-jupyter__options-item border-radius-lg">
                      <v-icon class="etype-jupyter__options-item-icon"
                        >format_list_numbered</v-icon
                      >
                      <v-switch
                        v-model="item.metadata.showLines"
                        inset
                        title="Lines in editor will be shown for user"
                      >
                      </v-switch>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col
                  v-if="item.cell_type == cellTypes[1]"
                  cols="4"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="4"
                >
                  <v-card
                    :class="[
                      'transparent',
                      ['md', 'sm', 'xs'].includes($vuetify.breakpoint.name)
                        ? 'pt-2'
                        : 'pl-2',
                    ]"
                    :elevation="0"
                  >
                    <v-row class="etype-jupyter__options-item border-radius-lg">
                      <v-icon class="etype-jupyter__options-item-icon"
                        >menu_book</v-icon
                      >
                      <v-switch
                        v-model="item.metadata.runnable"
                        inset
                        title="Code will be runnable by user"
                      ></v-switch>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col
                  v-if="item.cell_type == cellTypes[1]"
                  cols="4"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="4"
                >
                  <v-card
                    :class="[
                      'transparent',
                      ['md', 'sm', 'xs'].includes($vuetify.breakpoint.name)
                        ? 'pt-2'
                        : 'pl-2',
                    ]"
                    :elevation="0"
                  >
                    <v-row class="etype-jupyter__options-item border-radius-lg">
                      <v-icon class="etype-jupyter__options-item-icon"
                        >playlist_play</v-icon
                      >
                      <v-switch
                        v-model="item.metadata.readOnly"
                        inset
                        title="Code will not be edited by user"
                      ></v-switch>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-flex
              xs10
              @click="changeIndex(index)"
              @dblclick="prepareCellEdit(index)"
              class="pa-2"
            >
              <div v-if="item.cell_type == cellTypes[0]">
                <div v-if="activeContentIndex == index">
                  <quillEditor
                    @blur="saveCellContent()"
                    @focusout="saveCellContent()"
                    :options="getEditorOption()"
                    v-model="activeTmpContent"
                  />
                </div>
                <div v-if="activeContentIndex != index" v-html="item.html" />
              </div>
              <div v-if="item.cell_type == cellTypes[1]">
                &nbsp;[{{ item.execution_count }}]
                <v-icon @click="runCode(index)" title="Run code"
                  >play_arrow</v-icon
                >
                <codemirror
                  v-if="activeContentIndex == index"
                  @focus="prepareCellEdit(index)"
                  @blur="saveCellContent()"
                  :options="getCmOptions(false, 3, item.metadata.showLines)"
                  v-model="activeTmpContent"
                />
                <codemirror
                  v-if="activeContentIndex != index"
                  @focus="prepareCellEdit(index)"
                  @blur="saveCellContent()"
                  :options="getCmOptions(false, 3, item.metadata.showLines)"
                  :value="getData(index)"
                />
                <v-card
                  rounded
                  v-if="
                    item.outputs.length > 0 || item.temp.parentHeader != null
                  "
                  :elevation="0"
                >
                  <v-card-text>
                    <v-icon class="btn-close" @click="item.outputs = []"
                      >close</v-icon
                    >
                    <div v-for="(item2, index2) in item.outputs" :key="index2">
                      <pre v-if="item2.atype == 'text'" class="pre-wrap-text">{{
                        item2.output
                      }}</pre>
                      <div v-if="item2.atype == 'png'">
                        <v-slider
                          v-model="item2.slider"
                          class="align-self-stretch"
                          min="10"
                          max="500"
                          step="1"
                        ></v-slider>
                        <v-img
                          :src="'data:image/png;base64,' + item2.output"
                          :width="(item2.width * item2.slider) / 100"
                        />
                      </div>
                    </div>
                    <v-text-field
                      outlined
                      dense
                      v-if="item.temp.parentHeader != null"
                      autofocus
                      v-model="item.temp.data"
                      :label="item.temp.inputText + ' (and press Enter)'"
                      @keydown.enter.prevent="sendInputData(index)"
                    />
                  </v-card-text>
                </v-card>
              </div>
              <div v-if="item.cell_type == cellTypes[2]">
                <codemirror
                  v-if="activeContentIndex == index"
                  @focus="prepareCellEdit(index)"
                  @blur="saveCellContent()"
                  :options="getCmOptions(false, 3, false)"
                  v-model="activeTmpContent"
                />
                <div v-if="activeContentIndex != index" v-html="item.html" />
              </div>
              <div v-if="item.cell_type == cellTypes[3]">
                <div v-if="activeContentIndex == index">
                  <VueMathjax
                    :formula="activeTmpContent"
                    :options="getFormulaOption()"
                  />
                  <br />
                  <codemirror
                    @focus="prepareCellEdit(index)"
                    @blur="saveCellContent()"
                    :options="getCmOptions(false, 3, false)"
                    v-model="activeTmpContent"
                    style="margin-top: 15px"
                  />
                </div>
                <VueMathjax
                  v-if="activeContentIndex != index"
                  :formula="getData(index)"
                  :options="getFormulaOption()"
                />
              </div>
              <div v-if="item.cell_type == cellTypes[4]">
                <codemirror
                  v-if="activeContentIndex == index"
                  @focus="prepareCellEdit(index)"
                  @blur="saveCellContent()"
                  :options="getCmOptions(false, 3, true)"
                  v-model="activeTmpContent"
                />
                <div v-if="activeContentIndex != index" v-html="item.html" />
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text>
          <v-layout row justify-center>
            <v-menu class="lang-wrapper" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  class="lang-change-widget background-transparent shadow-none"
                >
                  mdi-plus-circle-outline
                </v-icon>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(item, index) in cellTypes"
                  :key="index"
                  @click="addCell(index)"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { codemirror } from "vue-codemirror";
import { VueMathjax } from "vue-mathjax";
import { quillEditor } from "vue-quill-editor";
import "codemirror/lib/codemirror.css";
import * as es from "../../assets/editor_settings.js";
import {
  prepareJupyterTextContent,
  deleteHTMLJupyterPart,
} from "../../assets/misc.js";
//import JptrCore from './jptr_core.vue'

export default {
  data() {
    return {
      Cells: [],
      cellTypes: ["editor", "code", "markdown", "equation", "raw"],
      activeContentIndex: -1,
      activeTmpContent: "",
      //activeTmpFormula: 'my eq ||sum_(i=1)^n i^3=((n(n+1))/2)^2[[1,2],[3,4]]||',
    };
  },
  computed: {},
  props: {
    id: Number,
    format: String,
    my_element: String,
    my_elementA: Array,
    objectChangePermission: Boolean,
  },
  computed: mapGetters([
    "getSavePrepareList",
    "getShowTaskIndex",
    "getEditTaskIndex",
    "getUpdateList",
    "getCodeForRunAnswer",
    "getCodeDeleteResults",
    "getCodeInputData",
    "getCodeKernelReset",
  ]),
  mounted() {
    this.initData();
  },
  components: {
    codemirror,
    quillEditor,
    VueMathjax,
    //        JptrCore
  },
  methods: {
    getEditorOption() {
      return es.getEditorOption();
    },
    getFormulaOption() {
      return es.getFormulaOption();
    },
    getFormulaOptionLatex() {
      return es.getFormulaOptionLatex();
    },

    initData() {
      this.$store.commit("deleteFromUpdateList", this.id); // if refresh from user
      this.Cells = [];
      if (this.format == "json") {
        if (this.my_element.length > 0)
          this.Cells = JSON.parse(this.my_element);
      }
      if (this.format == "json-content") {
        if (this.my_element.length > 0)
          this.Cells = JSON.parse(this.my_element).content;
      }
      if (this.format == "array") {
        this.Cells = this.my_elementA;
      }
      for (let i = 0; i < this.Cells.length; i++) {
        this.Cells[i].html = prepareJupyterTextContent(this.Cells[i].source);
        this.Cells[i].temp = {};
        if (this.Cells[i].metadata.runnable == null)
          this.Cells[i].metadata.runnable = true;
        if (this.Cells[i].metadata.showLines == null)
          this.Cells[i].metadata.showLines = true;
        if (this.Cells[i].metadata.readOnly == null)
          this.Cells[i].metadata.readOnly = false;
      }
      this.activeContentIndex = -1;
    },
    getCmOptions(_readOnly, _lines = 1, _line_numbers = true) {
      return es.getCmOptionsLines(
        "text/x-python",
        _readOnly,
        _lines,
        _line_numbers
      );
    },
    getData(_index) {
      var _dt = "";
      for (let i = 0; i < this.Cells[_index].source.length; i++)
        _dt += this.Cells[_index].source[i];
      return _dt;
    },
    prepareCellEdit(_index) {
      this.saveCellContent();
      this.activeContentIndex = _index;
      this.activeTmpContent = "";
      for (let i = 0; i < this.Cells[_index].source.length; i++) {
        this.activeTmpContent += this.Cells[_index].source[i];
      }
    },
    saveCellContent() {
      if (this.activeContentIndex == -1) return;
      this.Cells[this.activeContentIndex].source = [];
      const _arr = this.activeTmpContent.split("\n");
      for (let i = 0; i < _arr.length; i++) {
        if (i == _arr.length - 1)
          this.Cells[this.activeContentIndex].source.push(_arr[i]);
        else this.Cells[this.activeContentIndex].source.push(_arr[i] + "\n");
      }
      if (this.Cells[this.activeContentIndex].cell_type == this.cellTypes[2])
        this.Cells[this.activeContentIndex].html = prepareJupyterTextContent(
          this.Cells[this.activeContentIndex].source
        );
      else this.Cells[this.activeContentIndex].html = this.activeTmpContent;
    },
    addCell(_cellTypeIndex) {
      this.Cells.push({
        //1,0,  {
        cell_type: this.cellTypes[_cellTypeIndex],
        execution_count: 0,
        metadata: {
          runnable: true,
          showLines: true,
          readOnly: false,
        },
        outputs: [],
        source: [""],
        html: "",
        temp: {},
      });
      this.changeIndex(this.Cells.length - 1);
    },
    changeIndex(_index) {
      if (_index == this.activeContentIndex) return;
      if (_index > this.Cells.length - 1) return; // if cell was actually deleted
      this.prepareCellEdit(_index);
    },
    changeCellType(_index, _typeIndex) {
      this.saveCellContent();
      this.changeIndex(_index);
      this.Cells[this.activeContentIndex].cell_type =
        this.cellTypes[_typeIndex];
    },
    deleteCell(_index) {
      this.saveCellContent();
      this.Cells.splice(_index, 1);
      this.activeContentIndex = -1;
    },
    moveCellUp(_index) {
      this.saveCellContent();
      this.activeContentIndex = -1;
      const _cell = {
        cell_type: this.Cells[_index].cell_type,
        execution_count: this.Cells[_index].execution_count,
        metadata: this.Cells[_index].metadata,
        outputs: this.Cells[_index].outputs,
        source: this.Cells[_index].source,
        html: this.Cells[_index].html,
        temp: this.Cells[_index].temp,
      };
      this.Cells.splice(_index, 1);
      this.Cells.splice(_index - 1, 0, _cell);
    },
    moveCellDown(_index) {
      this.saveCellContent();
      this.activeContentIndex = -1;
      const _cell = this.getCellCopy(_index);
      this.Cells.splice(_index, 1);
      this.Cells.splice(_index + 1, 0, _cell);
    },
    duplicateCell(_index) {
      this.saveCellContent();
      this.activeContentIndex = -1;
      const _cell = this.getCellCopy(_index);
      this.Cells.push(_cell);
    },
    getCellCopy(_index) {
      return {
        cell_type: this.Cells[_index].cell_type,
        execution_count: this.Cells[_index].execution_count,
        metadata: this.Cells[_index].metadata,
        outputs: this.Cells[_index].outputs,
        source: this.Cells[_index].source,
        html: this.Cells[_index].html,
        tmp: this.Cells[_index].tmp,
      };
    },
    saveComponentData() {
      this.saveCellContent();
      this.$store.commit("pushToSaveData", {
        id: this.id,
        data: deleteHTMLJupyterPart(this.Cells),
      });
    },
    openMathAPI() {
      window.open("https://asciimath.org/");
    },
    runCode(_index) {
      const _data = {
        // sekcia lebo element/answer z ktoreho to ide
        index: _index,
        code: this.Cells[_index].source.join(""),
        execution_count: this.Cells[_index].execution_count,
      };
      this.Cells[_index].execution_count =
        this.Cells[_index].execution_count + 1;
      this.Cells[_index].outputs = [];
      this.$store.commit("setCodeForRun", _data);
    },
    processResult() {
      const _answer = this.getCodeForRunAnswer;
      this.$store.commit("setCodeForRunAnswer", null);
      const _data = {
        output: _answer.result.outputs,
        atype: _answer.atype,
        width: _answer.width,
        slider: 100,
      };
      this.Cells[_answer.index].outputs.push(_data);
    },
    prepareInputData() {
      this.$store.commit("setCodeInputData", {
        step: 2,
        parentHeader: this.getCodeInputData.parentHeader,
        inputText: this.getCodeInputData.inputText,
        data: "",
        index: this.getCodeInputData.index,
      });
      this.Cells[this.getCodeInputData.index].temp = {
        parentHeader: this.getCodeInputData.parentHeader,
        inputText: this.getCodeInputData.inputText,
        data: "",
      };
    },
    sendInputData(_index) {
      this.$store.commit("setCodeInputData", {
        step: 3,
        parentHeader: this.Cells[_index].temp.parentHeader,
        inputText: "",
        data: this.Cells[_index].temp.data,
        index: _index,
      });
      this.Cells[_index].outputs.push({
        output:
          this.Cells[_index].temp.inputText +
          " " +
          this.Cells[_index].temp.data,
        atype: "text",
      });
      this.Cells[_index].temp = {};
    },
    processKernelReset() {
      this.$store.commit("setCodeKernelReset", false);
      this.Cells.forEach((item) => {
        item.temp = {};
      });
    },
    deleteResults() {
      this.$store.commit("setCodeDeleteResults", false);
      this.Cells.forEach((item) => {
        item.outputs = [];
        item.execution_count = 0;
      });
    },
  },
};
</script>

<style>
.CodeMirror {
  border: 1px solid #eee;
  height: auto;
}
</style>
